// extracted by mini-css-extract-plugin
module.exports = {"container":"_1WCyq","details":"_4BmIl"};